<template>
  <div class="container">
    <div v-if="authen == 'signup'" >
      <div  class="text-login"> 
        <h1 class="h1-login">Sign up</h1>
        <h4>to set up your profile in business name card</h4>
      </div>
      <div class="consent">
        <div class="policy-wrap">
          <label class="policy-contain">
            <input class="policy-checkbox" type="checkbox" name="isService" value="" id="isConsent">
            <span class="policy-span"></span>
          </label>
        </div>
        <div class="text-policy-term">
          <p class="text-policy">I agree and 
            <a target="_blank"
              rel="noopener noreferrer"
              aria-expanded="false" 
              href="https://www.sic.co.th/acceptable-use-policy/" class="privacy">consent to SIC collecting</a> 
              (either directly from you or from other sources) and using your data for the purposes of analytics and targeting, promotion or marketing of products and services, and sending you newsletters, special offers, promotions, information regarding products and services and communications</p>
        </div>
      </div>
      <div class="policy">
        <div class="text-policy-signup">
          <p class="text-policy">By clicking "SIGN UP", you agree to our
            <a target="_blank"
              rel="noopener noreferrer"
              aria-expanded="false" 
              href="https://www.sic.co.th/terms-of-service/" class="privacy">terms of service </a>and 
            <a target="_blank"
              rel="noopener noreferrer"
              aria-expanded="false" 
              href="https://www.sic.co.th/privacy-policy-of-nfc-business-name-card/" class="privacy">privacy policy</a></p>
        </div>
      </div>
      <div class="wrap-btn">
        <div class="btn" @click="SignIn">
          <a target="_self"
            rel="noopener noreferrer"
            aria-expanded="false">
          Sign up</a>
        </div>
        <div class="userManual">
          <a class="manual-contain" href="User_Manual_of_NFC_Smart_Business_Card.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-expanded="false" >
            <img class="manual-image" src="../../src/assets/usermanual.png" alt="" width="16">
            <p>User Manual</p>
          </a>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="text-login"> 
        <h1 class="h1-login">Login</h1>
        <h4>to set up your profile in business name card</h4>
      </div>
      <div class="wrap-btn">
        <div class="btn" @click="SignIn">
          <a target="_blank"
            rel="noopener noreferrer"
            aria-expanded="false">
          LOG IN</a>
        </div>
        <div class="userManual">
          <a class="manual-contain" href="User_Manual_of_NFC_Smart_Business_Card.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-expanded="false" >
            <img class="manual-image" src="../../src/assets/usermanual.png" alt="" width="16">
            <p>User Manual</p>
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import auths from '../store/auth/auths.js'
import actions from '../store/user/actions';

export default {
  name: 'LoginSetup',
  props: {
    authen: String
  },
  data() {
    return {
      account: "",
    };
  },
  mounted() {
    if (auths.myMSAL == null)
    {
      return;
    }
  },
  methods: {
    async SignIn() {
      if(this.authen == "signup")
      {
        var newsStatus = document.getElementById("isConsent").checked;
        actions.isAccepted = true;
        actions.isReceiveNews = newsStatus;
        actions.recieveNewsStatus = true;
      }

      var authStatus = await auths.SignIn();
      this.account = auths.myAccounts;
      if(authStatus == true) {
        this.$emitter.emit('loginSuccess', this.account);
      }
    },
    
  }
}

</script>

<style>
.manual-contain {
  float: right;
  color: #3cd2ef;
  display: flex;
  text-decoration: none;
  font-size: 0.9em;
}
.manual-image {
  margin-right: 0.2rem;
}
.swal2-html-container {
  font-size: 4vw;
  margin-top: 2rem;
}
body {
  width: 100%;
}
.h1-login {
  color: #3cd2ef;
  margin: 0;
  font-size: 2.5em;
}
.userManual {
  margin: auto;
  margin-top: 1rem;
  width: 45%;
}
h4 {
  color: white;
}
.container {
  width: 100%;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.text-login {
  margin: auto;
  width: 70%;
  margin-bottom: 2.5rem;
}
.text-manual {
  margin: auto;
  margin-top: 5em;
  width: 60%;
}
.line {
  width: 70%;
  border: 1px solid #3cd2ef;
}
.privacy {
  color: #3cd2ef;
  text-decoration: none;
}
.btn {
  margin: auto;
  width: 30%;
  margin-top: 0.8em;
  padding: 15px 35px;
  text-align: center;
  text-transform: uppercase;
  font-size: 1.2em;
  font-weight: bold;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  border-radius: 10px;
  background-image: linear-gradient(to right, #3cd2ef 0%, #3c9bef 51%, #3c9bef 80%);
}
.btn:hover {
  background-position: right center; /* change the direction of the change here */
  background-image: linear-gradient(to right, #3c9bef 0%, #3c9bef 51%, #3cd2ef 100%);
}
.consent {
  margin: auto;
  margin-top: 1rem;
  width: 70%;
}
.policy {
  margin: auto;
  width: 70%;
  margin-top: 1rem;
}
.policy-term {
  display: flex;
  margin: 0;
  text-align: center;
  justify-content: center;
}
.policy-wrap {
  margin: 0;
  color: white;
  font-size: 0.6em;
  position: relative;
}
.policy-contain {
  vertical-align: middle;
  position: relative;
  bottom: 1px;
}
/* Hide the browser's default checkbox */
.policy-contain input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
/* On mouse-over, add a grey background color */
.policy-contain:hover input ~ .policy-span {
  background-color: #ccc;
}
/* When the checkbox is checked, add a blue background */
.policy-contain input:checked ~ .policy-span {
  background-color: #00bfe6;
}
/* Show the checkmark when checked */
.policy-contain input:checked ~ .policy-span:after {
  display: block;
}
/* Style the checkmark/indicator */
.policy-contain .policy-span:after {
  left: 0.4em;
  width: 0.3rem;
  height: 0.5rem;
  border: solid rgb(255, 255, 255);
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.policy-checkbox {
  vertical-align: middle;
  position: relative;
  bottom: 1px;
}
.policy-span {
  position: absolute;
  height: 0.8rem;
  width: 0.9rem;
  background-color: #eee;
  border-radius: 0.1rem;
}
/* Create the checkmark/indicator (hidden when not checked) */
.policy-span:after {
  content: "";
  position: absolute;
  display: none;
}
.text-policy-term {
  margin: 0;
  color: white;
  font-size: 0.7rem;
  margin-left: 1.8em;
  text-align: justify;
}
.text-policy-signup {
  margin: 0;
  color: white;
  font-size: 0.8rem;
  text-align: center;
}
.text-policy {
  line-height: 1rem;
  text-justify: inter-word;
}
.cookie-consent-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2147483645;
  box-sizing: border-box;
  width: 100%;
  background-color: #F1F6F4;
  box-shadow: 0 -3px 10px 0 rgb(172 171 171 / 30%);
  animation: 1s ease-out 0s 1 slideUpFromBottom;
}
.cookie-consent-banner-inner {     
  max-width: 100%;
  margin: 0 auto;
  padding: 18px 0;
}
.cookie-consent-banner-actions
{
  text-align: center;
}
.cookie-consent-banner-copy { 
  margin-bottom: 16px;
}
.cookie-consent-banner-description {
  font-family: "CeraPRO-Regular", sans-serif, arial;
  font-weight: normal;
  color: #838F93;
  font-size: 0.9em;
  line-height: 24px;
  text-align: center;
  margin-left: 1.5em;
  margin-right: 1.5em;
}
.cookie-consent-banner-cta {
  box-sizing: border-box;
  display: inline-block;
  min-width: 23vw;
  padding: 7px 9px;
  border-radius: 2px;
  background-color: #424664;
  color: #FFF;
  text-decoration: none;
  text-align: center;
  font-family: "CeraPRO-Regular", sans-serif, arial;
  font-weight: normal;
  font-size: 1em;
  line-height: 20px;
}
.cookie-consent-banner-cta--secondary { 
  padding: 5px 9px;
  border: 2px solid #3A4649;
  background-color: transparent;
  color: #424664;
}
.cookie-consent-banner-cta:hover {
  background-color: #33b4ce;
}
.cookie-consent-banner-cta--secondary:hover {
  border-color: #838F93;
  background-color: transparent;
  color: #c82222;
}
.cookie-consent-banner-cta:last-child {
  margin-left: 16px;
}
@keyframes slideUpFromBottom {
  0%,
  50% {
    transform: translateY(100%);
    opacity: 0;
  }
    
  60% {
    transform: translateY(50%);
    opacity: 1;
  
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  
  }
}
@media screen and (min-width: 660px) {
  /* .wrap-btn {
    height: 25vh;
  } */
  .userManual {
    width: 36%;
    height: 20vh;
  }
  .container {
    position: relative;
    transform: translateY(0);
    padding-top: 10%;
    padding-bottom: 10%;
  }
}
@media screen and (max-width: 300px){
  .text-policy-term {
    font-size: 0.6rem;
  }
  .btn {
    padding: 4vw 10vw;
  }
}
</style>